import "../scss/style.scss";
import $ from 'jquery';
import "./animation.js"
import "./lib/ofi.min.js";

$(function ($) {
	var windowWidth = $(window).width();
	var windowSm = 767;
	if (windowWidth <= windowSm) {
		var headerHight = $(".header").height();
	} else {
		var headerHight = $(".header").height();
	}
	$(window).on('ready load', function() {
		var url = $(location).attr('href');
		if(url.indexOf("#") != -1){
			var anchor = url.split("#");
			var target = $('#' + anchor[anchor.length - 1]);
			if(target.length){
				var position = Math.floor(target.offset().top) - headerHight;
				$("html, body").animate({ scrollTop : position},80);
			}
		}
	});
	$('a[href^="#"]').on('click', function () {
		var speed = 800;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? "html" : href);
		var position = target.offset().top - headerHight;
		$("body,html").animate({ scrollTop : position }, speed, "swing");
		return false;
	});
});

// SP nav
$(document).ready(function () {
	$('.js-nav-bt').on('click', function () {
		if ($('.js-nav-content').hasClass('close')) {
			$(".js-nav-content").removeClass('close');
			$(this).removeClass('close');
		} else {
			$(".js-nav-content").addClass('close');
			$(this).addClass('close');
		}
	});
	$('.js-nav-bt.close, .js-nav-link').on('click', function () {
		$(".js-nav-content, .js-nav-bt.close").removeClass('close');
		$(".js-nav-content, .js-nav-bt.close").removeClass('close');
	});
});

$(function() {
		$('.js-submit').attr('disabled', 'disabled');
				$('.js-chkbox').click(function() {
				if ( $(this).prop('checked') == false ) {
						$('.js-submit').attr('disabled', 'disabled');
				} else {
						$('.js-submit').removeAttr('disabled');
				}
		});
});

// contact error
$(function ($) {
	if ( $('.error')[0] ) {
		$('.errorBox,.inputInquiry,textarea,.checkGroup,.confirm__btBox .button').addClass('errorColor');
		$('.js-submit').removeAttr('disabled');
	}
});

jQuery(function ($) {
	// sp 100vh adjustment
	$(window).on('load resize', function () {
		let vh = document.documentElement.clientHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');
	});
});
